import clsx from 'clsx'

import { isDevelopment } from '@/utils/isDevelopment'

import { Link } from '@/components/CustomLink'
import { Warning } from '@/components/Warning'

import { ResolvedField } from '../../../../lib/contentful/utils'

type Props = {
	className?: string
	color?: string
	lineHeight?: number
	alignment?: 'left' | 'center' | 'right' | 'justify'
	link?: { href: string; target?: '_blank' | '_self' }
	openInNewTab?: boolean
	textField: ResolvedField
	slugField: ResolvedField
}

export function ContentfulLink({
	className,
	textField,
	slugField,
	color,
	lineHeight,
	alignment = 'left',
	link
}: Props) {
	if ('error' in textField) {
		if (isDevelopment()) return <Warning className={className}>{textField.error}</Warning>
		return null
	}
	if ('error' in slugField) {
		if (isDevelopment()) return <Warning className={className}>{slugField.error}</Warning>
		return null
	}
	if (typeof textField.data !== 'string') {
		if (isDevelopment()) return <Warning className={className}>Text is not a string.</Warning>
		return null
	}

	const href = link?.href.concat('error' in slugField ? '' : `/${slugField.data}`) ?? '#'

	/** In Makeswift editors may add or not a trailing slash to the link href, so we need to sanitize it */
	const sanitizedHref = href.replace(/([^:]\/)\/+/g, '$1')

	return (
		<Link
			href={sanitizedHref}
			target={link?.target}
			className={clsx(
				'hover:underline',
				className,
				{
					left: 'text-left',
					right: 'text-right',
					center: 'text-center',
					justify: 'text-justify'
				}[alignment]
			)}
			style={{ color, lineHeight }}
		>
			{textField.data}
		</Link>
	)
}
